import React, { useMemo } from "react"
import router from "next/router"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import { BookingSteps } from "../../app-core/_common/steps/booking-steps"
import styles from "./StepsNav.module.scss"
import { Step } from "./Step/Step"
import { tabState } from "./utils"
import StepSeparator from "./Step/StepSeparator"

type Props = {
    className?: string
    activeStep: BookingSteps
}

const StepsNav: React.FC<Props> = ({ className, activeStep }) => {
    const [state] = useECommerceMachine()
    const steps = useMemo(() => state.context.flowVersion.steps.steps(router, state), [router, state])
    const activeIndex = steps.findIndex((s) => s.id == activeStep)

    return (
        <nav className={styles.steps} data-content-name="header-steps-nav">
            {steps.map((step, index) => {
                const lastStep = index == steps.length - 1
                const state = tabState(step.completed(), activeIndex, index, step.canGoto())
                return (
                    <React.Fragment key={step.id}>
                        <Step
                            index={index}
                            key={step.id}
                            state={state}
                            onClick={step.goto}
                            dataContentPiece={`step-${step.id}`}
                        >
                            {step.label}
                        </Step>
                        {!lastStep && <StepSeparator state={state} />}
                    </React.Fragment>
                )
            })}
        </nav>
    )
}

export default StepsNav
